var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isDisabledHeader())?_c('top-bar'):_vm._e(),_c('main',{attrs:{"className":"main"}},[_c('router-view')],1),_c('status-bar',{ref:"statusBar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }